<!--
  This file is part of vospace-ui
  Copyright (C) 2021 Istituto Nazionale di Astrofisica
  SPDX-License-Identifier: GPL-3.0-or-later
-->
<template>
<b-modal id="move-or-copy-modal" :title="title" :okTitle="okTitle" @show="afterShow" @ok.prevent="moveOrCopyNodes" :ok-disabled="!writable" size="lg">
  <b-form inline v-if="this.nodesToMoveOrCopy.length === 1 && this.moveOrCopy === 'copy'" class="mb-3">
    <label class="w-25" for="new-name-input">New name</label>
    <b-form-input v-model.trim="newName" id="new-name-input" class="w-75" aria-describedby="new-name-input-feedback" :state="newNameState" v-on:input="resetNewNameError" @keydown.native.enter.prevent="moveOrCopyNodes">
    </b-form-input>
    <b-form-invalid-feedback id="new-folder-name-input-feedback" class="text-right">{{newNameError}}</b-form-invalid-feedback>
  </b-form>
  <ol class="breadcrumb">
    <li class="breadcrumb-item" v-for="(item, i) in breadcrumbs" :key="i" :class="{ 'active' : item.active }">
      <a href="#" @click.stop.prevent="breadcrumbClick(i)" v-if="!item.active">{{item.text}}</a>
      <span v-if="item.active">{{item.text}}</span>
    </li>
  </ol>
  <div id="move-or-copy-nodes-wrapper">
    <div id="move-or-copy-nodes"></div>
  </div>
  <div v-if="selectedNotCopiableNodes.length > 0" class="mt-3">
    <p><strong>Warning</strong>: following selected nodes can't be copied and will be ignored:</p>
    <p>
    <ul>
      <li v-for="node in selectedNotCopiableNodes" :key="node">{{node}}</li>
    </ul>
    </p>
  </div>
  <div v-if="selectedNotMovableNodes.length > 0" class="mt-3">
    <p><strong>Warning</strong>: following selected nodes can't be moved and will be ignored:</p>
    <p>
    <ul>
      <li v-for="node in selectedNotMovableNodes" :key="node">{{node}}</li>
    </ul>
    </p>
  </div>
</b-modal>
</template>

<script>
export default {
  name: 'MoveOrCopyModal',
  computed: {
    nodesToMoveOrCopy() { return this.$store.state.nodesToMoveOrCopy },
    destinationPath() { return this.$store.state.moveOrCopyDestination },
    writable() { return this.$store.state.moveOrCopyDestinationWritable },
    moveOrCopy() { return this.$store.state.moveOrCopy },
    selectedNotMovableNodes() { return this.$store.state.selectedNotMovableNodes },
    selectedNotCopiableNodes() { return this.$store.state.selectedNotCopiableNodes },
    title() {
      let text = this.moveOrCopy === 'move' ? 'Move ' : 'Copy ';
      if (this.nodesToMoveOrCopy.length === 1) {
        text += this.nodesToMoveOrCopy[0];
      } else {
        text += this.nodesToMoveOrCopy.length + ' nodes';
      }
      text += ' to ' + this.destinationPath;
      return text;
    },
    okTitle() { return (this.moveOrCopy === 'move' ? 'Move nodes' : 'Copy nodes') },
    breadcrumbs() {
      let items = [];
      if (this.destinationPath !== null) {
        let pathSplit = this.destinationPath.split('/');
        for (let i = 0; i < pathSplit.length; i++) {
          items.push({
            text: i === 0 ? 'ROOT' : pathSplit[i],
            active: i === pathSplit.length - 1
          });
        }
      }
      return items;
    },
    newNameState() {
      if (this.newNameError) {
        return false;
      }
      return null;
    }
  },
  data() {
    return {
      newName: null,
      newNameError: null
    }
  },
  methods: {
    afterShow() {
      // starts from parent path
      let firstSelectedNode = this.nodesToMoveOrCopy[0];
      let lastSlashPos = firstSelectedNode.lastIndexOf('/');
      this.$store.dispatch('openNodeInMoveOrCopyModal', firstSelectedNode.substring(0, lastSlashPos));
      if (this.nodesToMoveOrCopy.length === 1 && this.moveOrCopy === 'copy') {
        this.newName = firstSelectedNode.substring(lastSlashPos + 1);
      } else {
        this.newName = null;
      }
    },
    breadcrumbClick(i) {
      let pathSplit = this.destinationPath.split('/');
      let path = pathSplit.slice(0, i + 1).map(p => encodeURIComponent(p)).join('/');
      if (path === '') {
        path = '/';
      }
      this.$store.commit('setMoveOrCopyDestination', path);
      window.openNodeInMoveOrCopyModal(event, path);
    },
    moveOrCopyNodes() {
      let direction = this.destinationPath;

      if (this.nodesToMoveOrCopy.length === 1 && this.moveOrCopy === 'copy') {
        if (!this.newName) {
          this.newNameError = "Name is required";
          return;
        } else if (/[<>?":\\/`|'*]/.test(this.newName)) {
          this.newNameError = "Name contains an illegal character. Following characters are not allowed: < > ? \" : \\ / | ' * `";
          return;
        }

        direction += '/' + this.newName;
      }

      this.$store.dispatch('moveOrCopyNodes', {
          targets: this.nodesToMoveOrCopy,
          direction,
          keepBytes: this.moveOrCopy === 'copy'
        })
        .then(() => {
          this.$bvModal.hide('move-or-copy-modal');
        })
    },
    resetNewNameError() {
      this.newNameError = null;
    }
  }
}
</script>

<style>
#move-or-copy-nodes .list-group-item {
  /* reduced padding */
  padding-top: .35rem;
  padding-bottom: .35rem;
}

#move-or-copy-nodes-wrapper {
  max-height: 300px;
  overflow-y: auto;
}
</style>
